/* this may need deleting when roles are defined and received from server */

const COORDINATOR = 'coordinator';
const REQUESTER = 'requester';
const CRB_APPROVER_GROUP = 'CRB';
const MOBILE_COMMUNICATIONS_CHECK = 'Mobile Communications Check';
const CHANGE_MANAGEMENT = 'Change Management';
const ICM_CHANGE_MANAGEMENT = 'VNO INCP Change Management';

/* Flow Statuses */
const RAISING_CRQ = 'RAISING_CRQ';
const VIEWING_CRQ = 'VIEWING_CRQ';

/* Edit Statuses */
/* Statuses during the "create crq flow", AKA main-form flow */
// first time the user sees a section
const ES_RAISING_NEW_SECTION = 'ES_RAISING_NEW_SECTION';
// when the user navigates to a section they've seen before via back/next
const ES_RAISING_EDIT_SECTION = 'ES_RAISING_EDIT_SECTION';
// when the user navigates to a section they've seen before via the summary page
const ES_RAISING_EDIT_FROM_SUMMARY = 'ES_RAISING_EDIT_FROM_SUMMARY';

/* Statuses during the "view crq flow", ie coordinator review */
// when the section is being saved in the form.
const ES_VIEWING_NEW_SECTION = 'ES_VIEWING_NEW_SECTION';
// when the user navigates to a section via the summary page
const ES_VIEWING_EDIT_SECTION = 'ES_VIEWING_EDIT_SECTION';

// mapping editing statuses to flow statuses
const RAISING_CRQ_EDITING_STATUSES = [
  ES_RAISING_NEW_SECTION,
  ES_RAISING_EDIT_SECTION,
  ES_RAISING_EDIT_FROM_SUMMARY,
];

const VIEWING_CRQ_EDITING_STATUSES = [
  ES_VIEWING_NEW_SECTION,
  ES_VIEWING_EDIT_SECTION,
];


export {
  COORDINATOR,
  REQUESTER,
  CRB_APPROVER_GROUP,
  CHANGE_MANAGEMENT,
  ICM_CHANGE_MANAGEMENT,
  MOBILE_COMMUNICATIONS_CHECK,
  RAISING_CRQ,
  VIEWING_CRQ,
  ES_RAISING_NEW_SECTION,
  ES_RAISING_EDIT_SECTION,
  ES_RAISING_EDIT_FROM_SUMMARY,
  ES_VIEWING_NEW_SECTION,
  ES_VIEWING_EDIT_SECTION,
  RAISING_CRQ_EDITING_STATUSES,
  VIEWING_CRQ_EDITING_STATUSES,
};
